import { render, staticRenderFns } from "./TransferGraduationInstitutionInfoForm.vue?vue&type=template&id=14866d42&scoped=true&"
import script from "./TransferGraduationInstitutionInfoForm.vue?vue&type=script&lang=ts&"
export * from "./TransferGraduationInstitutionInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./TransferGraduationInstitutionInfoForm.vue?vue&type=style&index=0&id=14866d42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14866d42",
  null
  
)

export default component.exports